import axios from 'axios';
export async function getMaintenancePlanning(token) {
    const res = await axios.get('/api/Planning/GetMaintenancePlanning', getHeaders(token));
    try {

        for (let i = 0; i < res.data.length; i++) {
                res.data[i].startDate = new Date(res.data[i].startDate);
                res.data[i].endDate = new Date(res.data[i].endDate);
        }
        return res.data;
    }
    catch {
        return res;
    }
}

export async function getQuotes(token) {
    const res = await axios.get('/api/WorkTask/GetQuotes', getHeaders(token));
    try {
        return res.data;
    }
    catch {
        return res;
    }
}

export async function updateContract(token, contractOid, maintenancePlanned, lastMaintenanceDate) {
    return await axios.patch(`/api/Contract/Patch/${contractOid}`, {
        LastMaintenanceDate: lastMaintenanceDate ? new Date(lastMaintenanceDate).toISOString() : undefined,
        MaintenancePlanned: maintenancePlanned,
    }, getHeaders(token));
}

const getHeaders = (token) => {
    return {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        }
    };
};
